const BannerShimmer = () => {
  return (
   <div className="w-full h-40 sm:h-56 bg-gray-300 animate-pulse rounded-lg" />
  );
};

export default BannerShimmer;
